<template>
  <div class="w-full h-full">
    <Card v-if="error">
      <CardHeader>
        <CardTitle>Could not open this offer</CardTitle>
        <CardDescription>{{ error }}</CardDescription>
      </CardHeader>
      <CardContent>
        <Button variant="outline" size="sm" @click="$router.back()">Go back</Button>
      </CardContent>
    </Card>

    <Card v-else>
      <CardHeader>
        <CardTitle>Loading offer…</CardTitle>
        <CardDescription>Preparing the offer for editing.</CardDescription>
      </CardHeader>
      <CardContent class="space-y-2">
        <Skeleton class="h-8 w-64" />
        <Skeleton class="h-8 w-full" />
      </CardContent>
    </Card>
  </div>
</template>

<script>
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  Button,
  Skeleton,
} from '@boogi/ui'
import { addOfferWizard } from '@/stores/addOfferWizard'

// Editing reuses the "Add your own offer" wizard rather than a separate form: this page
// loads the offer, seeds the shared wizard store and hands over to the wizard's own steps.
//
// The previous implementation was a duplicate wizard whose step bodies had been replaced
// with the plain <Card> container from the UI kit, so every step rendered an empty box and
// nothing on the page was editable.
export default {
  name: 'edit-offer',
  components: { Card, CardHeader, CardTitle, CardDescription, CardContent, Button, Skeleton },
  data() {
    return { error: '' }
  },
  computed: {
    offerId() {
      return this.$route.params.offerId
    },
  },
  created() {
    this.loadOffer()
  },
  methods: {
    async loadOffer() {
      try {
        const apiUrl = localStorage.getItem('apiUrl') || process.env.VUE_APP_API_URL
        const token = localStorage.getItem('token')
        const response = await this.$apiFetch(
          `${apiUrl}/private/api/client/catalogue/offer/${this.offerId}`,
          {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', Authorization: `${token}` },
          }
        )
        if (!response.ok) {
          this.error = 'This offer could not be loaded. It may have been removed.'
          return
        }
        const offer = await response.json()
        addOfferWizard.seedFromOffer(offer)
        // Straight to the offer details step — retailer, matching and MIDs are already
        // set from the saved offer, and every step is reachable from the stepper.
        this.$router.replace('/add-offer/info')
      } catch (e) {
        this.error = 'Could not reach the server. Please try again.'
      }
    },
  },
}
</script>
